import React from 'react';
import { useGet } from 'store';
import { Card } from 'antd';

import { Table } from '_src/components';
import services from '_src/services';
import { PageContainer } from '_src/shared/styles';
import { stylesTablet } from './styles';

const resource = 'documents';
const config = services[resource];

export default () => {
  const { data, busy: loadingGet } = useGet({
    ...config.getDocuments
  });

  const expandedRowRender = record => {
    const tableData = [...data];
    const afpDocs = [
      '7-31-24 Driver Score Handbook.pdf',
      '8-28 2 pager afp cheat sheet.pdf',
      'AFP Intervention Form.pdf'
    ];

    const filteredData =
      record.key === 'afp'
        ? tableData.filter(e => afpDocs.includes(e.name))
        : tableData.filter(e => !afpDocs.includes(e.name));

    return <Table columns={config.table} data={filteredData} />;
  };

  const groupedColumns = [
    {
      title: 'Document',
      dataIndex: 'name',
      key: 'name'
    }
  ];
  const groupedData = [
    { key: 'afp', name: 'Driver Scoring and AFP' },
    { key: 'training', name: 'Driver Scoring Training' }
  ];

  return (
    <PageContainer style={stylesTablet}>
      <Card title="AFP Documents">
        <Table
          columns={groupedColumns}
          data={groupedData}
          expandedRowRender={expandedRowRender}
          expandRowByClick
          loading={loadingGet}
          onRow={() => ({
            style: { cursor: 'pointer' }
          })}
        />
      </Card>
    </PageContainer>
  );
};
